export const itemModel = {
  id: "",
  name: "",
  body: "",
  label: "",
  color: "",
  index: "",
  age: [24, 35],
  showAge: true,
  edit: false,
  categories: [],
  assets: [],
  motivations: [],
  ideal: [],
  needs: [],
  challenges: [],
  children: [],
};

export const initialState = () => {
  return {
    id: "",
    name: "",
    body: "",
    label: "",
    color: "",
    index: "",
    age: [24, 35],
    showAge: true,
    edit: false,
    categories: [],
    assets: [],
    motivations: [],
    ideal: [],
    needs: [],
    challenges: [],
    children: [],
  };
};

export const colors = [
  { title: "None", color: "" },
  { title: "Red", color: "#F44336" },
  { title: "Dark Red", color: "#B71C1C" },
  { title: "Pink", color: "#E91E63" },
  { title: "Purple", color: "#9C27B0" },
  { title: "Dark Purple", color: "#673AB7" },
  { title: "Light Purple", color: "#E1BEE7" },
  { title: "Indigo", color: "#3F51B5" },
  { title: "Blue", color: "#2196F3" },
  { title: "Light Blue", color: "#03A9F4" },
  { title: "Cyan", color: "#00BCD4" },
  { title: "Teal", color: "#009688" },
  { title: "Green", color: "#4CAF50" },
  { title: "Light Green", color: "#8BC34A" },
  { title: "Dark Green", color: "#1B5E20" },
  { title: "Yellow", color: "#FFEB3B" },
  { title: "Brown", color: "#795548" },
  { title: "Lime", color: "#CDDC39" },
  { title: "Amber", color: "#FFC107" },
  { title: "Orange", color: "#FF9800" },
  { title: "Deep Orange", color: "#FF5722" },
  { title: "Grey", color: "#607D8B" },
  { title: "Neutral Grey", color: "#9E9E9E" },
];
